import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-class",
  "use": "icon-class-usage",
  "viewBox": "0 0 1251 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1251 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-class\"><path d=\"M1192.932 1023.317H711.68c-12.97 0-32.057-40.789-32.057-40.789 170.41-27.876 342.87-55.068 531.03-85.675V126.464h40.903v803.015c-0.683 33.309-36.808 92.473-58.624 93.838zM656.44 934.912V260.409c-6.116-145.493 62.037-205.34 184.747-227.1C935.936 16.326 1032.732 11.548 1143.154 0c0 280.15-0.683 796.217-0.683 796.217l0.683 66.645c-0.683 0.654-249.486-19.058-486.713 72.05z m-543.972-72.05l0.683-66.645S112.469 280.149 112.469 0c110.45 11.548 207.247 16.327 301.995 33.308 122.71 22.443 190.862 82.29 184.718 227.1v674.504c-237.88-91.108-486.713-71.396-486.713-72.05zM538.54 1024H59.989C38.855 1022.635 0.683 963.47 0 930.162V127.147h42.951v769.706c188.814 30.607 358.542 57.8 528.981 85.675 0 0-19.768 40.79-33.393 41.472z\" fill=\"#D0141C\" p-id=\"4289\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/class.svg
// module id = KTQf
// module chunks = 197